import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
  Manager,
  Target as Trigger,
  Popper as Content
} from 'react-popper'
import isClickOutside from './utils/isClickOutside'
import styles from './Tether.css'

const propTypes = {
  /** Determines where content appears next to target. See valid placements http://bit.ly/2h4UjTZ */
  placement: PropTypes.oneOf([
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start',
  ]),
  /** Array of type of events to trigger popover on. ['click', 'hover', 'contextMenu'] */
  triggerOn: PropTypes.array,
  /** Class name on wrapper */
  className: PropTypes.string,
  /** Class name on trigger wrapper */
  triggerClassName: PropTypes.string,
  /** Class name on popover content wrapper */
  contentClassName: PropTypes.string,
  /** If true, tether will close when popover contents clicked */
  closeOnClick: PropTypes.bool,
  /** If true, tether will close when mouse leaves */
  closeOnMouseLeave: PropTypes.bool,
  /** If true, tether will close when another element clicked */
  closeOnClickAway: PropTypes.bool,
  // TODO add events onClose, onOpen functions
}

const defaultProps = {
  triggerOn: ['click'],
}

export default class Tether extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: props.isOpen || false
    }
  }
  componentDidMount () {
    document.body.addEventListener('click', this.handleClickOutside)

    // fix for collapsing spans
    const trigger = this.trigger
    if (trigger && trigger.children[0]) {
      const width = trigger.children[0].offsetWidth
      const height = trigger.children[0].getBoundingClientRect().height
      trigger.style.minWidth = width + 'px'
      trigger.style.minHeight = height + 'px'
    }
  }
  componentWillUnmount () {
    document.body.removeEventListener('click', this.handleClickOutside)
  }
  handleClickOutside = (e) => {
    const isOutsideClick = isClickOutside(this.wrapper, event)
    if (isOutsideClick && this.state.isOpen) {
      this.close()
    }
  }
  handleTriggerClick = (event) => {
    event.preventDefault()
    this.setState({
      isOpen: !this.state.isOpen
    })
  }
  handleContentClick = (event) => {
    if (this.props.closeOnClick && this.state.isOpen) {
      this.close()
    }
  }
  open = (e) => {
    this.setState({
      isOpen: true
    })
  }
  close = (e) => {
    this.setState({
      isOpen: false
    })
  }
  renderTrigger() {
    const { children, triggerClassName, triggerOn } = this.props
    const classes = classNames(triggerClassName, styles.trigger)
    const clickHander = (triggerOn.indexOf('click') !== -1) ? this.handleTriggerClick : noOp
    const contextHander = (triggerOn.indexOf('contextMenu') !== -1) ? this.handleTriggerClick : noOp
    return (
      <Trigger
        innerRef={(div) => { this.trigger = div }}
        component={'div'}
        className={classes}
        onContextMenu={contextHander}
        onClick={clickHander}>
        {children}
      </Trigger>
    )
  }
  renderContent() {
    const { isOpen } = this.state
    const { triggerOn, placement, contentClassName, content } = this.props

    if (!isOpen) {
      return null
    }

    var offsetTopModifier = function(data) {
      console.log('DATA', data)
      data.offsets.popper.top += 50
      return data;
    }
    // custom popper.js mods for future use
    const mods = {
      // preventOverflow: {
      //   boundariesElement: 'viewport'
      // },
      // Will need these for advanced placement
      offsetTopModifier: {
        enabled: true,
        fn: function(data) {
          console.log('DATA', data)
          data.offsets.popper.top += 50
          return data;
        }
      }
      // offset: {
      //   offset: 1110
      // },
    }
    //  modifiers={mods}
    const clickHander = (triggerOn.indexOf('click') !== -1) ? this.handleContentClick : noOp
    const classes = classNames(contentClassName, styles.content)
    return (
      <Content
        innerRef={(div) => { this.content = div }}
        placement={placement}
        onClick={clickHander}
        // modifiers={mods}
        className={classes}>
        {content}
      </Content>
    )
  }
  render() {
    const { placement, className, triggerOn } = this.props

    const mouseEnterHandler = (triggerOn.indexOf('hover') !== -1) ? this.open : noOp
    const mouseLeaveHandler = (triggerOn.indexOf('hover') !== -1) ? this.close : noOp
    const classes = classNames(className, styles.wrapper)
    const container = (props) => {
      return (
        <span
          ref={(div) => { this.wrapper = div }}
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          className={classes}>
          {props.children}
        </span>
      )
    }

    return (
      <Manager tag={container}>
         {this.renderTrigger()}
         {this.renderContent()}
      </Manager>
    )
  }
}

Tether.propTypes = propTypes
Tether.defaultProps = defaultProps

const noOp = () => {}



// WEBPACK FOOTER //
// ../src/components/Tether/Tether.js